class CustomDetails extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.summary = this.querySelector("[data-summary]");
    this.content = this.querySelector("[data-content]");
    this.toggle = this.querySelector("[data-toggle]");

    if (this.content && !this.content.id) {
      this.content.id = `custom-details-content-${Math.random().toString(36).slice(2, 8)}`;
    }

    this.summary?.addEventListener("click", (e) => {
      this.isOpen ? this.close() : this.open();
    });

    this.toggle?.addEventListener("click", () => {
      this.isOpen ? this.close() : this.open();
    });

    if (this.summary) {
      if (this.content) this.summary.setAttribute("aria-controls", this.content.id);
    }

    if (this.toggle) {
      if (this.content) this.toggle.setAttribute("aria-controls", this.content.id);
    }

    this._setExpanded("false")
  }

  _forceOpen() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.setAttribute("open", "");
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  _forceClosed() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.removeAttribute("open");
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  get isOpen() {
    return this.hasAttribute("open");
  }

  _setExpanded(value) {
    this.summary?.setAttribute("aria-expanded", value);
    this.toggle?.setAttribute("aria-expanded", value);
  }

  open() {
    if (this.isOpen) return;
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.setAttribute("open", "");
    this._setExpanded("true");
    // if (this.hasAttribute('focus-toggle-on-open') && this.toggle) {
    //   this.toggle.focus();
    // }

    if (this.content) {
      this.content.style.height = 0;
      this.content.style.opacity = 0;

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.content.style.opacity = 1;
      });
    }
  }

  close() {
    if (!this.isOpen) return;
    this._setExpanded("false");
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.removeAttribute("open");
        // if (this.hasAttribute('focus-toggle-on-open') && this.toggle) {
        //   this.summary.focus();
        // }
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.content.style.height = 0;
      this.content.style.opacity = 0;
    } else {
      this.removeAttribute("open");
    }
  }
}

if (!customElements.get("custom-details")) {
  customElements.define("custom-details", CustomDetails);
}
